<template>
    <div class="admin-attendance-filter">
        <Card dis-hover>
            <Row type="flex">
                <Col :xs="2" :sm="4" :md="4" :lg="4" class="d-flex-center user-col">
                    <Select
                        v-model="selectedEmployee"
                        :value="$route.query.user"
                        filterable
                        clearable
                        placeholder="All Employees"
                        @on-change="handleUserChanged"
                    >
                        <Option v-for="item in filterEmployeeList" :key="item.key" :value="item.value">
                            {{ item.name }}
                        </Option>
                    </Select>
                </Col>
                <Col :xs="2" :sm="4" :md="4" :lg="4" class="d-flex-center status-col">
                    <Select
                        v-model="selectedStatus"
                        :value="$route.query.status"
                        filterable
                        clearable
                        placeholder="Filter by"
                        @on-change="handleStatusChanged"
                    >
                        <Option v-for="item in filterStatus" :key="item.value" :value="item.value">
                            {{ item.name }}
                        </Option>
                    </Select>
                </Col>
                <Col :xs="4" :sm="6" :md="6" :lg="15" class="d-flex-center export-btn">
                    <Button class="pt-btn-3" @click="handleExportCsv"> Export as CSV </Button>
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import Bugsnag from '@bugsnag/js';
// import moment from 'moment';
export default {
    props: {
        filterEmployees: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            selectedStatus: this.$route.query.status,
            selectedEmployee: this.$route.query.user,
            filterEmployeeList: [],
        };
    },
    watch: {
        filterEmployees(data) {
            this.filterEmployeeList = data;
        },
    },

    created() {
        if (this.$route.query.status) {
            this.$emit('status-changed', this.selectedStatus);
        }
        if (this.$route.query.user) {
            this.$emit('user-changed', this.selectedEmployee);
        }
    },

    methods: {
        handleUserChanged(user) {
            this.$emit('user-changed', user);
            try {
                this.$router.replace({ query: null }).catch(() => {});
            } catch (e) {
                Bugsnag.notify(e);
            }
        },
        handleExportCsv() {
            this.$emit('export-csv');
        },
        handleStatusChanged(stats) {
            this.$emit('status-changed', stats);
            try {
                this.$router.replace({ query: null }).catch(() => {});
            } catch (e) {
                Bugsnag.notify(e);
            }
        },
    },
};
</script>
<style lang="scss">
.admin-attendance-filter {
    .ivu-row {
        .export-btn {
            justify-content: end;
            button {
                border-radius: 15px;
            }
        }
    }
    .user-col {
        margin-right: 10px;
    }
}
@media screen and (max-width: 767px) {
    .admin-attendance-filter {
        .ivu-row {
            display: block;

            .ivu-col {
                max-width: 100%;
            }
            .ivu-col-span-xs-2 {
                margin: 5px 0;
            }
            .filter-btn button {
                width: 100%;
            }
        }
    }
}
</style>
